jQuery(document).ready(function ($) {
  MktoForms2.loadForm("//go.mybudget.com.au", "253-OAJ-725", 1166, function (marketoForm) {
    const userDataKey = "mbUser";
    var mbUserData = new Map(JSON.parse(localStorage.getItem(userDataKey)));

    var form = $("#downloadableForm");
    var beforeMessage = $(".mb-downloadable-form-wrapper");
    var hasValidFName = false;
    var hasValidLName = false;
    var hasValidEmail = false;
    var hasValidPhone = false;

    const downloadablesObjs = [
      {
        pagePath: "4-debt-busting-strategies",
        formTitle: "4 Debt Busting Strategies eBook",
        actionType: "download-debt-management-ebook",
      },
      {
        pagePath: "10-steps-to-get-out-of-debt",
        formTitle: "10 Steps To Get Out Of Debt And Start Saving eBook",
        actionType: "download-10-steps-ebook",
      },
      {
        pagePath: "6-steps-to-eliminate-credit-card-debt-ebook",
        formTitle: "6 Steps To Eliminate Credit Card Debt eBook",
        actionType: "download-6-steps-credit-card-debt-ebook",
      },
      {
        pagePath: "personal-budget-template",
        formTitle: "Personal Budget template",
        actionType: "download-budget-template",
      },
      {
        pagePath: "christmas-budget-template",
        formTitle: "Christmas Budget template",
        actionType: "download-christmas-budget-template",
      },
      {
        pagePath: "get-a-better-deal-checklist",
        formTitle: "Get A Better Deal checklist",
        actionType: "download-better-deal-checklist",
      },
      {
        pagePath: "get-a-better-deal-checklist-1",
        formTitle: "Get A Better Deal checklist",
        actionType: "download-better-deal-checklist",
      },
      {
        pagePath: "goals-template",
        formTitle: "Goal Setting template",
        actionType: "download-mygoals-template",
      },
      {
        pagePath: "tax-return-checklist",
        formTitle: "Tax return checklist",
        actionType: "download-tax-return-checklist",
      },
      {
        pagePath: "save-money-on-your-electricity-bill",
        formTitle: "Save money on your electricity bill checklist",
        actionType: "download-energy-audit-checklist",
      },
      {
        pagePath: "home-buyers-guide",
        formTitle: "Home Buyers Guide",
        actionType: "download-home-buyers-guide",
      },
      {
        pagePath: "budgeting-and-financial-goals-secrets",
        formTitle: "Budgeting and Financial Goals Secrets Webinar",
        actionType: "download-webinar-financial-goals",
      },
      {
        pagePath: "healthy-meal-planning-budget-guide",
        formTitle: "Healthy meal planning on a budget guide",
        actionType: "download-cheap-meal-guide",
      },
    ];
    const downloadableObj = getCurrentDownloadableObj(getCurrentPagePath());

    var firstNameText = $("#downloadableForm #fName");
    var lastNameText = $("#downloadableForm #lName");
    var emailText = $("#downloadableForm #email");
    var phoneText = $("#downloadableForm #phone");
    var phoneError = $("#phoneError");
    var submitBtn = $("#downloadableForm #downloadableSubmitBtn");

    const formTitle = $(".form-title");
    const formSubtitle = $(".form-desc");
    const formType = form.find('input[id="formType"]');

    var typingTimerFName;
    var typingTimerLName;
    var typingTimerEmail;
    var typingTimerPhone;

    var typingInterval = 200;

    prePopulateForm();

    form.submit(function (event) {
      // Push form submissions to Mouseflow
      // https://help.mouseflow.com/en/articles/4274450-forms-with-no-successful-submits
      window._mfq = window._mfq || [];
      window._mfq.push(["formSubmitAttempt", "#downloadableForm"]);

      validateAllFields();
      if (isFormValid()) {
        setUserData();
        var fName = firstNameText.val();
        var lName = lastNameText.val();
        var email = emailText.val();
        var phone = phoneText.val();

        submitBtn.prop("disabled", true);
        submitBtn.val("Please Wait");
        submitBtn.fadeTo("slow", 0.5);

        hasValidFName = false;
        hasValidLName = false;
        hasValidEmail = false;
        hasValidPhone = false;
        event.preventDefault();
        event.returnValue = false;

        var actionType = getDownloadableActionType();

        marketoForm.addHiddenFields({
          FirstName: fName,
          LastName: lName,
          Email: email,
          Phone: phone,
          subscriptionNewsletter: true,
          lastFormCompleted: actionType,
        });
        marketoForm.submit();
        marketoForm.onSuccess(function (values, followUpUrl) {
          dataLayer.push({
            event: "download_resource",
            mb_resource_name: actionType,
          });
          dataLayer.push({
            event: "subscribe_newsletter",
            mb_newsletter_form_type: formType.val(),
          });

          // Push form submissions to Mouseflow
          window._mfq.push(["formSubmitSuccess", "#downloadableForm"]);

          submitBtn.animate({ opacity: 0 }, 300);
          beforeMessage.fadeOut(function () {
            formTitle.show().find("h4").text("Thank you for providing your details");
            formSubtitle.html(
              "<p>You will receive an email shortly with your free " + downloadableObj.formTitle + ".</p>"
            );
            form.trigger("reset");

            // Scroll to welcome message if not visible
            var offset = formTitle.offset().top;
            var visible_area_start = $(window).scrollTop() + 70;
            var visible_area_end = visible_area_start + window.innerHeight - 100;
            if (offset < visible_area_start || offset > visible_area_end) {
              // Not in view so scroll to it
              $("html,body").animate({ scrollTop: offset - window.innerHeight / 3 }, 1000);
            }
          });
          return false;
        });
      } else {
        // Push form submissions to Mouseflow
        window._mfq.push(["formSubmitFailure", "#downloadableForm"]);

        event.preventDefault();
        event.returnValue = false;
      }
    });

    firstNameText.on("input", function () {
      clearTimeout(typingTimerFName);
      typingTimerFName = setTimeout(validateFirstName, typingInterval);
    });

    lastNameText.on("input", function () {
      clearTimeout(typingTimerLName);
      typingTimerLName = setTimeout(validateLastName, typingInterval);
    });

    emailText.on("input", function () {
      clearTimeout(typingTimerEmail);
      typingTimerEmail = setTimeout(validateEmail, typingInterval);
    });

    phoneText.on("input", function () {
      clearTimeout(typingTimerPhone);
      typingTimerPhone = setTimeout(validatePhone, typingInterval);
    });

    phoneText.on("change", function () {
      formatPhone();
    });

    function validateAllFields() {
      validateFirstName();
      validateLastName();
      validateEmail();
      validatePhone();
    }

    function getCurrentDownloadableObj(path) {
      // Using filter method to suport IE
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
      var result = downloadablesObjs.filter(function (o) {
        return o.pagePath.toLowerCase().replace(/\\|\//g, "") == path;
      });
      return result ? result[0] : null;
    }

    function getCurrentPagePath() {
      var currentPath = window.location.pathname;
      return currentPath.toLowerCase().replace(/\\|\//g, "");
    }

    function getDownloadableActionType() {
      return downloadableObj ? downloadableObj.actionType : "";
    }

    firstNameText.focusout(function () {
      toggleFloatLabelClass(firstNameText);
      validateFirstName();
    });

    lastNameText.focusout(function () {
      toggleFloatLabelClass(lastNameText);
      validateLastName();
    });

    emailText.focusout(function () {
      toggleFloatLabelClass(emailText);
      validateEmail();
    });

    phoneText.focusout(function () {
      toggleFloatLabelClass(phoneText);
      validatePhone();
    });

    firstNameText.focusin(function () {
      $("label[for='" + firstNameText.attr("id") + "']").addClass("float-label");
      addFocusInClass(firstNameText);
    });

    lastNameText.focusin(function () {
      $("label[for='" + lastNameText.attr("id") + "']").addClass("float-label");
      addFocusInClass(lastNameText);
    });

    emailText.focusin(function () {
      $("label[for='" + emailText.attr("id") + "']").addClass("float-label");
      addFocusInClass(emailText);
    });

    phoneText.focusin(function () {
      $("label[for='" + phoneText.attr("id") + "']").addClass("float-label");
      addFocusInClass(phoneText);
    });

    function validateFirstName() {
      if (!firstNameText.val()) {
        $("#fNameError").html("You must enter a valid first name to proceed");
        addFieldErrorClass(firstNameText);
      } else {
        hasValidFName = isValidName(firstNameText.val());
        if (hasValidFName) {
          $("#fNameError").html("");
          addFocusOutClass(firstNameText);
        } else {
          $("#fNameError").html("Please provide a valid first name");
          addFieldErrorClass(firstNameText);
        }
      }
    }

    function validateLastName() {
      if (!lastNameText.val()) {
        $("#lNameError").html("You must enter a valid last name to proceed");
        addFieldErrorClass(lastNameText);
      } else {
        hasValidLName = isValidName(lastNameText.val());
        if (hasValidLName) {
          $("#lNameError").html("");
          addFocusOutClass(lastNameText);
        } else {
          $("#lNameError").html("Please provide a valid last name");
          addFieldErrorClass(lastNameText);
        }
      }
    }

    function validateEmail() {
      if (!emailText.val()) {
        $("#emailError").html("You must enter a valid email address to proceed (e.g. email@email.com)");
        addFieldErrorClass(emailText);
      } else {
        hasValidEmail = isValidEmail(emailText.val());
        if (hasValidEmail) {
          $("#emailError").html("");
          addFocusOutClass(emailText);
        } else {
          $("#emailError").html("Please provide a valid email address e.g email@email.com");
          addFieldErrorClass(emailText);
        }
      }
    }

    function validatePhone() {
      phoneText.val(phoneText.val().replace(/[^0-9+]/g, ""));
      if (!phoneText.val()) {
        phoneError.html("Please enter a valid Australian phone number.");
        addFieldErrorClass(phoneText);
      } else {
        hasValidPhone = isValidPhone(phoneText.val());
        if (hasValidPhone) {
          phoneError.html("");
          phoneText.removeClass("field_error");
          addFocusInClass(phoneText);
        } else {
          phoneError.html("Please enter a valid Australian phone number (e.g., 0881234567, 61881234567, +61881234567)");
          addFieldErrorClass(phoneText);
        }
      }
    }

    function formatPhone() {
      let regex = /^\+?61/;
      if (regex.test(phoneText.val())) {
        phoneText.val(phoneText.val().replace(regex, "0"));
      }
    }

    function isValidName(value) {
      if (/^[ a-zA-Z\-\’\']+$/.test(value.replace(/\s/g, ""))) {
        return true;
      } else {
        return false;
      }
    }

    function isValidEmail(value) {
      // if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
      if (
        /^(([^<>()[\]\\.,`~#?$%|^{}&\/*!=;:'\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        )
      ) {
        return true;
      } else {
        return false;
      }
    }

    function isValidPhone(value) {
      let regex1 = /^0[234578]\d{8}$/;
      let regex2 = /^(0|\+?61)[234578]\d{8}$/;

      if (regex2.test(value)) {
        return true;
      } else {
        return false;
      }
    }

    function isFormValid() {
      return hasValidFName && hasValidLName && hasValidEmail && hasValidPhone;
    }

    function addFocusInClass(element) {
      element.addClass("fieldFocusIn");
      element.removeClass("fieldFocusOut");
      element.removeClass("fieldError");
    }
    function addFocusOutClass(element) {
      element.addClass("fieldFocusOut");
      element.removeClass("fieldFocusIn");
      element.removeClass("fieldError");
    }
    function addFieldErrorClass(element) {
      element.addClass("fieldError");
      element.removeClass("fieldFocusIn");
      element.removeClass("fieldFocusIn");
    }

    function toggleFloatLabelClass(inputElement) {
      var label = $("label[for='" + inputElement.attr("id") + "']");
      if (!inputElement.val()) {
        label.removeClass("float-label");
      } else {
        label.addClass("float-label");
      }
    }

    function setUserData() {
      if (mbUserData !== null) {
        if (firstNameText.val()) mbUserData.set("fName", firstNameText.val());
        if (lastNameText.val()) mbUserData.set("lName", lastNameText.val());
        if (emailText.val()) mbUserData.set("email", emailText.val());
        if (phoneText.val()) mbUserData.set("phone", phoneText.val());

        localStorage.setItem(userDataKey, JSON.stringify(Array.from(mbUserData.entries())));
      }
    }

    function prePopulateForm() {
      if (mbUserData !== null) {
        for (const [key, value] of mbUserData.entries()) {
          var input = form.find('input[name="' + key + '"]');
          var label = form.find('label[for="' + key + '"]');
          if (input.length && label.length) {
            label.addClass("float-label");
            input.val(value);
          }
        }
      }
    }
  });
});
